import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { useTranslation } from "react-i18next";
import { GetTypographyContent } from "../../components/shared/Typography/Typography";
import { useDeviceHook } from "../../utils/hooks/useDeviceHook";
import { LANDING_PAGE_URL } from "../../utils/urlConstants";
import geneticCounselor from "../../assets/images/geneticCounselor.png";
import {
  GCLearnMoreWrapper,
  GCLearnMoreComponentWrapper,
  GCLearnMoreComponentGrid,
  GCLearnMoreContentWrapper,
  GCLearnMoreImageWrapper,
  GCLearnMoreBackLink,
} from "./GCLearnMore.styles";
import { BackIcon } from "../../assets/iconComponents/BackIcon";
import { TrackAnalyticsEvent } from "../../services/Analytics";
import { AnalyticsEventNames } from "../../utils/analyticsEvents";
import { getUserAuth } from "../../recoil/selectors";

const GCLearnMore = (): React.ReactElement => {
  const { t } = useTranslation();
  const { deviceType } = useDeviceHook();
  const history = useHistory();
  const auth = useRecoilValue(getUserAuth);

  useEffect(() => {
    const trackPageView = async () => {
      await TrackAnalyticsEvent(
        AnalyticsEventNames.GCLearnMorePageViewed,
        auth?.access_token,
      );
    };
    trackPageView();
  }, [auth?.access_token]);

  return (
    <GCLearnMoreWrapper>
      <GCLearnMoreComponentWrapper deviceType={deviceType}>
        <GCLearnMoreComponentGrid deviceType={deviceType}>
          <GCLearnMoreBackLink onClick={() => history.push(LANDING_PAGE_URL)}>
            <BackIcon />
            {GetTypographyContent({
              content: t("gcLearnMore.backToTests"),
              size: "medium",
              textColor: "redMedium",
            })}
          </GCLearnMoreBackLink>
          {GetTypographyContent({
            content: t("gcLearnMore.title"),
            size: "h2",
            textColor: "greyMedium",
            isBold: true,
          })}
          <GCLearnMoreContentWrapper deviceType={deviceType}>
            <GCLearnMoreImageWrapper deviceType={deviceType}>
              <img alt="genetic-counselor" src={geneticCounselor} />
            </GCLearnMoreImageWrapper>
            {GetTypographyContent({
              content: t("gcLearnMore.readyDescription"),
              size: "medium",
              textColor: "greyMedium",
              className: "gc-learn-more-top",
            })}
            <div className="gc-learn-more-section">
              {GetTypographyContent({
                content: t("gcLearnMore.scopeDescription"),
                size: "medium",
                textColor: "greyMedium",
                padding: "0 0 20px 0",
              })}
              {GetTypographyContent({
                content: t("gcLearnMore.euNotice"),
                size: "medium",
                textColor: "greyMedium",
                padding: "0 0 20px 0",
              })}
            </div>
          </GCLearnMoreContentWrapper>
        </GCLearnMoreComponentGrid>
      </GCLearnMoreComponentWrapper>
    </GCLearnMoreWrapper>
  );
};

export default GCLearnMore;
